const am = {
  // Navbar
  home: 'ዋና ገጽ', clients: 'ደንበኞች', news: 'ዜና', about: 'ስለ እኛ',
  contact: 'ያግኙን', signIn: 'ግባ', register: 'ተመዝገብ',
  signOut: 'ውጣ', myDashboard: 'የእኔ ዳሽቦርድ', team: 'ቡድን',

  // Ad splash
  adOf: (i, n) => `ማስታወቂያ ${i} ከ ${n}`,
  watchAd: 'ለመቀጠል ማስታወቂያውን ይመልከቱ',
  secondsLeft: (s) => `${s} ሰከንድ ቀርቷል`,
  overall: 'አጠቃላይ', complete: 'ተጠናቋል',

  // Home
  heroTag: 'ፈቃድ ያላቸው ንግዶች ብቻ',
  heroTitle1: 'ኢ-ኮሜርስ እና ዲጂታል ማርኬቲንግ',
  heroTitle2: 'ለፈቃድ ያላቸው ንግዶች',
  heroDesc: 'ትክክለኛ የሶሻል ሚዲያ ተሳትፎ እና የኢ-ኮሜርስ መፍትሄዎችን ለመፍጠር ከተረጋገጡ ፈቃድ ካላቸው ንግዶች ጋር ብቻ እንሰራለን።',
  // Links page
  linksTagline: 'ኢ-ኮሜርስ እና ዲጂታል ማርኬቲንግ · አዲስ አበባ፣ ኢትዮጵያ',
  linksDesc: 'ተረጋግጠው ፈቃድ ያላቸው ንግዶች በዲጂታል ማርኬቲንግ፣ ኢ-ኮሜርስ እና ትክክለኛ የሶሻል ሚዲያ ተሳትፎ እንዲያድጉ እንረዳለን።',
  linksWebsite: 'ድህረ ገጽ',
  applyNow: 'አሁን ያመልክቱ',
  viewClients: 'ደንበኞችን ይመልከቱ',
  seeMore: 'እዚህ ጋ ይነልከቱ →',
  totalClients: 'ደንበኞች', licensed: 'ፈቃድ ያላቸው', avgGrowth: 'አማካይ እድገት',
  ourServices: 'አገልግሎቶቻችን',

  // Clients categories
  catAll: 'ሁሉም', catStartups: 'ስታርተፖች እና ስራ ፈጣሪዎች',
  catRetail: 'ችርቻሮ እና ጅምላ', catHospitality: 'ሆቴልና ቱሪዝም',
  catEducation: 'የትምህርት ተቋማት', catServices: 'አገልግሎት ሰጪዎች',
  catManufacturers: 'አምራቾች',
  allCities: '📍 ሁሉም ከተሞች', clearFilter: '✕ አጽዳ',
  noClientsInCity: (city) => `በ${city} ምንም ደንበኛ አልተገኘም።`,
  noClientsInCategory: 'በዚህ ምድብ ምንም ደንበኛ የለም።',

  // Clients
  ourClients: 'ደንበኞቻችን',
  verifiedBusinesses: 'የምናስተዋውቃቸው ተረጋግጠው ፈቃድ ያላቸው ንግዶች',
  verified: '✓ ተረጋግጧል',
  followers: 'ተከታዮች', growth: 'እድገት', engagement: 'ተሳትፎ',
  noClients: 'እስካሁን ደንበኞች የሉም።',

  // News
  newsTitle: 'ዜና', latestUpdates: 'የቅርብ ጊዜ ዜናዎች እና ጽሑፎች',
  readMore: 'ተጨማሪ ያንብቡ →', noNews: 'እስካሁን ጽሑፎች የሉም።',
  loading: 'በመጫን ላይ...',
  sourceRef: '📎 ምንጭ / ማጣቀሻ →',
  categories: { General: 'አጠቃላይ', Marketing: 'ማርኬቲንግ', Business: 'ንግድ', Technology: 'ቴክኖሎጂ', News: 'ዜና', Events: 'ዝግጅቶች', Tips: 'ምክሮች' },

  // About
  aboutTitle: 'ስለ እኛ', aboutSub: 'እኛ ነን',
  vision: 'ራዕይ', mission: 'ተልዕኮ',
  visionText: 'MSMEዎችን ለማብቃት ኢትዮጵያ ውስጥ ቀዳሚ የዲጂታል ማርኬቲንግ እና ማስታወቂያ ኩባንያ መሆን።',
  missionText: 'የኢትዮጵያ MSMEዎች ዘላቂ እድገት እንዲያሳኩ የሚረዱ ፈጠራዊ፣ ተመጣጣኝ እና ሊለካ የሚችሉ የማርኬቲንግ እና ማስታወቂያ መፍትሄዎችን ማቅረብ።',
  coreValues: 'መሰረታዊ እሴቶች',
  strategicObjectives: 'ስትራቴጂካዊ ዓላማዎች',
  so1: 'በሀገር አቀፍ ደረጃ ሙያዊ የማርኬቲንግ አገልግሎቶችን ማቅረብ',
  so2: 'MSMEዎችን በዲጂታል ታይነት እና ብራንዲንግ ማሳደግ',
  so3: 'ቴክኖሎጂን (ድህረ ገጽ፣ ሞባይል አፕ እና ሶሻል ሚዲያ) ለአገልግሎት አቅርቦት መጠቀም',
  so4: 'ከMSMEዎች እና ተቋማት ጋር የረጅም ጊዜ አጋርነት መገንባት',
  so5: 'ለተሰጠ ወጣቶች የስራ ዕድሎችን መፍጠር',

  // Contact
  contactTitle: 'ያግኙን', contactSub: 'ንግድዎን ለማሳደግ ዝግጁ ነዎት?',
  fullName: 'ሙሉ ስም *', email: 'ኢሜይል', phone: 'ስልክ *',
  company: 'የኩባንያ ስም', businessType: 'የንግድ አይነት',
  tin: 'TIN ቁጥር', elmis: 'E-LMIS ምዝገባ',
  license: 'የንግድ ፈቃድ', message: 'መልዕክት',
  submit: 'ማመልከቻ ያስገቡ →', submitting: 'በማስገባት ላይ...',
  successTitle: 'መልዕክት ተልኳል!', successMsg: 'እናመሰግናለን! በቅርቡ እናገኝዎታለን።',
  sendAnother: 'ሌላ ይላኩ',
  licenseNote: '📋 አስፈላጊ: ፈቃድ ካላቸው ንግዶች ጋር ብቻ እንሰራለን።',
  selectType: 'አይነት ይምረጡ...',

  // Register
  registerTitle: 'የንግድ መለያ ይፍጠሩ',
  accountDetails: 'የመለያ ዝርዝሮች', businessInfo: 'የንግድ መረጃ', documents: 'ሰነዶች',
  namePlaceholder: 'ሙሉ ስም *', passwordPlaceholder: 'የይለፍ ቃል *',
  confirmPassword: 'የይለፍ ቃል ያረጋግጡ *', minPassword: 'ቢያንስ 6 ቁምፊዎች',
  nextBusiness: 'ቀጣይ: የንግድ መረጃ →', nextDocs: 'ቀጣይ: ሰነዶች →',
  back: '← ተመለስ', createAccount: 'መለያ ፍጠር →', creating: 'መለያ በመፍጠር ላይ...',
  alreadyHave: 'አስቀድሞ መለያ አለዎት?',
  businessLicenseReq: 'የንግድ ፈቃድ ቁጥር ያስፈልጋል።',
  licenseInfo: '📋 መረጃዎ በቡድናችን ይገመገማል። ከተመዘገቡ በኋላ ኢሜይል ይደርስዎታል።',
  companyNameLabel: 'የኩባንያ / ንግድ ስም *',
  businessTypeLabel2: 'የንግድ አይነት',
  locationLabel: 'አካባቢ (ከተማ)',
  websiteLabel: 'ድህረ ገጽ (አማራጭ)',
  businessLicenseLabel: 'የንግድ ፈቃድ ቁጥር *',
  tinLabel: 'TIN ቁጥር',
  elmisLabel: 'E-LMIS ምዝገባ',
  phoneLabel2: 'ስልክ ቁጥር *',
  emailLabel: 'ኢሜይል (አማራጭ)',
  fullNameLabel: 'ሙሉ ስም *',
  businessDocsTitle: 'የንግድ ሰነዶች',
  businessDocsDesc: 'ፈቃድ ካላቸው ንግዶች ጋር ብቻ እንሰራለን። ኦፊሴላዊ ሰነድ ቁጥሮችዎን ያስገቡ።',
  fillRequired: 'ሁሉንም አስፈላጊ መስኮች ይሙሉ።',
  passwordMismatch: 'የይለፍ ቃሎቹ አይዛመዱም።',
  passwordShort: 'የይለፍ ቃሉ ቢያንስ 6 ቁምፊዎች መሆን አለበት።',
  companyRequired: 'የኩባንያ ስም ያስፈልጋል።',
  registrationFailed: 'ምዝገባ አልተሳካም።',

  // Login
  loginTitle: 'ወደ መለያዎ ይግቡ',
  phoneLabel: 'ስልክ ቁጥር',
  passwordLabel: 'የይለፍ ቃል',
  emailPlaceholder: 'your@email.com',
  loginBtn: 'ግባ →', loggingIn: 'በመግባት ላይ...',
  noAccount: 'መለያ የለዎትም?', registerBusiness: 'ንግድዎን ይመዝግቡ',
  loginFailed: 'መግባት አልተሳካም።',

  // Navbar extras
  blogsNews: 'ብሎጎች/ዜና',
  faq: 'ተደጋጋሚ ጥያቄዎች',
  cart: 'ጋሪ',
  expandSidebar: 'ሳይድባር አስፋ',
  collapseSidebar: 'ሳይድባር ቅዳ',

  // FAQ
  faqTitle: 'ተደጋጋሚ ጥያቄዎች',
  faqSubtitle: 'ስለ ኦል ቲንግስ፣ ባዛር እና አገልግሎቶቻችን ማንኛውም ነገር ማወቅ የሚፈልጉት።',
  faq1q: 'ኦል ቲንግስ ማነው?',
  faq1a: 'ኦል ቲንግስ በአዲስ አበባ፣ ኢትዮጵያ የመሰረተ ዲጂታል ማርኬቲንግ ኤጀንሲ እና የኢ-ኮሜርስ መድረክ ነው። ለተፈቃዱ የኢትዮጵያ ንግዶች በማርኬቲንግ አገልግሎቶች እና በባዛር ገበያ በመስራት በመስመር ላይ እንዲያድጉ እንረዳለን።',
  faq2q: 'እንዴት እንደ ሻጭ ልመዝገብ?',
  faq2a: 'ወደ ያግኙን ገጽ ቀጥል እና የንግድ ዝርዝሮችዎን በመጠቀም ቅጹን ይሙሉ፣ የTIN ቁጥር፣ የንግድ ፈቃድ እና የኤልሚስ ምዝገባ ጨምር። ቡድናችን ማመልከቻዎን ይገመግማል።',
  faq3q: 'ከባዛር እንዴት እን ይገዛ?',
  faq3a: 'በባዛር ውስጥ ምርቶችን ያሱ፣ እቃዎችን ወደ ጋሪዎ ያክሉ እና ወደ ክፍያ ቀጥል። በፊት እንደ ገዢ መመዝገብ ያለብዎት። ክፍያው በቀጥታ ከርስዎ ከሻጩ ጋር ይከናወናል።',
  faq4q: 'ምን ዓይነት የክፍያ ዘዴዎች ይቀበላሉ?',
  faq4a: 'የክፍያ ዘዴዎች በሻጭ ይለያያሉ። ብዙዎቹ የባንክ ዝውውር፣ ሞባይል ገንዘብ ወይም በአዲስ አበባ ውስጥ በመጋብዛት ይቀበላሉ። የሻጩን የክፍያ አማራጭ ለማየት የምርቱን ገጽ ይፈትሹ።',
  faq5q: 'ዴሊቨሪ እንዴት ይሠራል?',
  faq5a: 'ዴሊቨሪ አቀናብሮ ከመግዛት በኋላ በቀጥታ ከሻጩ ጋር ይከናወናል። ብዙ ሻጮች በአዲስ አበባ ውስጥ ዴሊቨሪ ይሰጣሉ። በቻት ባህሪ በመጠቀም ከሻጩ ጋር ስለ ዴሊቨሪ አማራጭ ማውራት ይችላሉ።',
  faq6q: 'የመመለሻ ፖሊሲ አለ?',
  faq6a: 'መመለሻዎች በርስዎ ከሻጩ ጋር ይከናወናል። መግዛት ከመፈረጋት በፊት የሻጩን የመመለሻ ፖሊሲ ለማረጋገጫ በመድረኩ ላይ መልዕክት መላክ እንመክራለን።',
  faq7q: 'እንዴት እንደ ዲጂታል ማርኬቲንግ ደንበኛ ልሆን?',
  faq7a: 'በያግኙን ገጽ ወይም በallthingsethiopia2026@gmail.com ያግኙን። የንግድ ፍላጎቶችዎን እንወያያለን እና ልዩ የማርኬቲንግ ዕቅድ እንፍጥራለን።',
  faq8q: 'ኦል ቲንግስ ምን አገልግሎቶች ያቀርባል?',
  faq8a: 'ለኢትዮጵያ ንግዶች ዲጂታል ማርኬቲንግ፣ የሶሻል ሚዲያ አስተዳደር፣ ድህረ ገጽ ግንባታ፣ ብራንዲንግ፣ ይዘት መፍጠር እና የኢ-ኮሜርስ መፍትሄዎች እንቀርባለን።',

  // About extras
  aboutTag: 'ስለ እኛ',
  aboutHeroTitle1: 'ኢትዮጵያን',
  aboutHeroTitle2: 'የዲጂታል ወደፊት ማበረታታት',
  aboutCatalyst: 'እኛ በዘመናዊ የንግድ ገበያ ውስጥ የኢትዮጵያ MSMEዎች እድገት መካከልኛ ነን።',
  whoWeAre: 'ማን ነን',
  whoWeAreText: 'እኛ የኢትዮጵያ MSMEዎች ከባህላዊ የንግድ ዘዴዎች ወደ ዘመናዊ፣ ቴክኖሎጂ-ተመሳሳይ እድገት እንዲመላለሱ የረዳ ዲጂታል ማርኬቲንግ እና የኢ-ኮሜርስ ድጋፍ መድረክ ነን። ተልዕኮአችን ከአካባቢ ጥራት እና ከዓለም አቀፍ ታይነት መካከል ያለውን ክፍተት መቀረዝ ነው።',
  ourCoreValues: 'መሰረታዊ',
  ourCoreValuesHighlight: 'እሴቶቻችን',
  strategic: 'ስትራቴጂካዊ',
  strategicHighlight: 'ዓላማዎች',

  // Register extras
  joinAllThings: 'ኦል ቲንግስ',
  joinAllThingsHighlight: 'ተቀላቀል',
  chooseAccountType: 'ለመጀመር የአካውንት አይነትዎን ይምረጡ',
  registerYourBusiness: 'ለሙያዊ ማስታወቂያ አገልግሎት ፈቃድ ያለውን ንግድዎን ይመዝግቡ።',
  haveAccount: 'አስቀድሞ መለያ አለዎት?',
  signIn: 'ግባ',
  registrationSubmitted: 'ምዝገባ ተልኳል!',
  thankYouName: (name) => `${name} አመሰግናለን!`,
  thankYouRegistering: 'መለያዎ በግምገማ ላይ ነው። ቡድናችን ንግድዎን በ48 ሰዓት ውስጥ ይረጋግጣል።',
  goToLogin: 'ወደ መግቢያ ተመለስ',
  phoneMustBe9: 'ስልኩ 9 ቁምፊዎች መሆን አለበት',
  selectCity: 'ከተማ ይምረጡ...',

  // Login extras
  forgot: 'ረሱ?',

  // Contact info card labels
  labelEmail: 'ኢሜይል',
  labelLocation: 'አድራሻ',
  labelPhone: 'ስልክ',
  labelHours: 'ሰዓት',
  labelTelegram: 'ቴሌግራም',
  labelWhatsApp: 'ዋትሳፕ',
  contactLocationCity: 'አካባቢ (ከተማ)',
  alertFullNameRequired: 'ሙሉ ስም ያስፈልጋል',
  alertPhoneDigits: 'ስልኩ 9 ቁምፊዎች መሆን አለበት (ለምሳሌ 911031884)',
  alertValidEmail: 'እባክዎ ትክክለኛ የኢሜይል አድራሻ ያስገቡ',
  alertSubmissionFailed: 'ማስገባት አልተሳካም። እባክዎ እንደገና ይሞክሩ።',

  // Chat
  messages: '💬 መልዕክቶች',
  noConversations: 'እስካሁን ውይይቶች የሉም።',
  selectConversation: 'ውይይት ይምረጡ ለመጀመር',
  typeMessage: 'መልዕክት ይጻፉ...',
  new: 'አዲስ',

  // Dashboard
  myDashboardTitle: 'የእኔ ዳሽቦርድ',
  underReview: 'መለያ በግምገማ ላይ',
  underReviewMsg: 'ቡድናችን የንግድ መረጃዎን እየገመገመ ነው። በ1-2 የስራ ቀናት ውስጥ እናገኝዎታለን።',
  profileTab: '👤 መገለጫ', businessTab: '🏢 የንግድ መረጃ',
  socialTab: '📱 ሶሻል እና ተጨማሪ', passwordTab: '🔒 የይለፍ ቃል',
  saveChanges: 'ለውጦችን አስቀምጥ', saving: 'በማስቀመጥ ላይ...',
  profileUpdated: 'መገለጫ በተሳካ ሁኔታ ተዘምኗል።',
  passwordChanged: 'የይለፍ ቃል በተሳካ ሁኔታ ተቀይሯል።',
  currentPassword: 'የአሁኑ የይለፍ ቃል', newPassword: 'አዲስ የይለፍ ቃል',
  confirmNewPassword: 'አዲስ የይለፍ ቃል ያረጋግጡ',
  changePassword: 'የይለፍ ቃል ቀይር',

  // Footer
  footerTagline: 'ኢ-ኮሜርስ እና ዲጂታል ማርኬቲንግ · አዲስ አበባ፣ ኢትዮጵያ',
  copyright: '© 2026 ኦል ቲንግስ ሶሉሽን PLC',

  // Client detail
  backToClients: '← ወደ ደንበኞች ተመለስ',
  established: 'የተቋቋመበት', location: 'አካባቢ',
  verifiedLicensed: 'ተረጋግጦ ፈቃድ ያለው ንግድ',
  licenseLabel: 'ፈቃድ',
  ourMarketingWork: 'የእኛ የማርኬቲንግ ስራ',
  videoContent: 'የቪዲዮ ይዘት',
  video: 'ቪዲዮ',
  watch: 'ይመልከቱ ↗',
  businessTypeLabel: 'የንግድ አይነት',
  contactSocial: 'ያግኙን እና ሶሻል ሚዲያ',
  sourceRef: '📎 ምንጭ / ማጣቀሻ →',

  // Services
  service1Title: 'የሶሻል ሚዲያ አስተዳደር',
  service1Desc: 'የሶሻል ሚዲያ መለያዎችዎን ሙሉ አስተዳደር',
  service2Title: 'ይዘት መፍጠር',
  service2Desc: 'ሙያዊ ፎቶዎች፣ ቪዲዮዎች እና ግራፊክስ',
  service3Title: 'የዕድገት ስትራቴጂ',
  service3Desc: 'ለዕድገት የውሂብ ላይ የተመሰረቱ ስትራቴጂዎች',
  service4Title: 'የሚከፈልበት ማስታወቂያ',
  service4Desc: 'በሁሉም መድረኮች ላይ ዒላማ ያደረጉ ማስታወቂያዎች',

  // Core values
  cv1Title: 'ፈጠራ እና ፈጠራ', cv1Desc: 'አዳዲስ ሀሳቦችን እና ፈጠራ መፍትሄዎችን እንቀበላለን',
  cv2Title: 'ደንበኛ ማዕከላዊ አገልግሎት', cv2Desc: 'የደንበኞቻችን ስኬት ለሁሉም ነገር ማዕከል ነው',
  cv3Title: 'ታማኝነት እና ግልጽነት', cv3Desc: 'በታማኝነት እና ግልጽነት እንሰራለን',
  cv4Title: 'ቴክኖሎጂ ተቀባይነት', cv4Desc: 'የቅርብ ጊዜ ዲጂታል መሳሪያዎችን እንጠቀማለን',
  cv5Title: 'ውጤት ተኮር አፈጻጸም', cv5Desc: 'ሊለካ በሚችሉ ውጤቶች ላይ እናተኩራለን',

  // Team
  teamOurPeople: 'ሰዎቻችን',
  teamTitle: 'ቡድናችንን',
  teamTitleHighlight: 'ይወቁ',
  teamSubtitle: 'ኦል ቲንግስ ሶሉሽን ጀርባ ያሉ ተሰጥኦ ያላቸው ሰዎች',
  teamMember: 'አባል', teamMembers: 'አባላት',
  depts: {
    'Executive Management': 'ስራ አስፈጻሚ አስተዳደር',
    'Creative & Digital Marketing': 'ፈጠራ እና ዲጂታል ማርኬቲንግ',
    'Technology & Platform Support': 'ቴክኖሎጂ እና መድረክ ድጋፍ',
    'Finance & Administration': 'ፋይናንስ እና አስተዳደር',
    'Customer & Sales': 'ደንበኛ እና ሽያጭ',
  },

  // Bazaar
  bazaarTitle: 'ባዛር',
  bazaarSubtitle: 'ከሁሉም ሻጮች ምርቶችን በአንድ ቦታ ያስሱ',
  sellerStoreTitle: 'የሻጭ መደብር',
  productDetailTitle: 'የምርት ዝርዝሮች',
  cartTitle: 'ጋሪዎ',
  checkoutTitle: 'ክፍያ',
  deliveryTitle: 'ዴሊቨሪ ይጠይቁ',
  addToCart: 'ወደ ጋሪ ጨምር',
  proceedToCheckout: 'ወደ ክፍያ ቀጥል',
  placeOrder: 'ትዕዛዝ ስጥ',
  confirmPayment: 'ክፍያ አረጋግጥ',
  rejectPayment: 'ክፍያ ውድቅ አድርግ',
  requestDelivery: 'ዴሊቨሪ ጠይቅ',
  addProduct: 'ምርት ጨምር',
  editProduct: 'ምርት አርትዕ',
  deleteProduct: 'ምርት ሰርዝ',
  outOfStock: 'ክምችት አልቋል',
  inStock: 'ክምችት አለ',
  pendingPayment: 'ክፍያ በመጠባበቅ ላይ',
  confirmedOrder: 'ተረጋግጧል',
  rejectedOrder: 'ውድቅ ሆኗል',
  removedByAdmin: 'በአስተዳዳሪ ተወግዷል',
  filterByCategory: 'በምድብ አጣራ',
  filterBySeller: 'በሻጭ አጣራ',
  priceRange: 'የዋጋ ክልል',
  searchProducts: 'ምርቶችን ፈልግ...',
  noResults: 'ምርቶች አልተገኙም።',
  selectBank: 'የክፍያ ዘዴ ምረጥ',
  bankAccountNumber: 'የሂሳብ ቁጥር',
  transferInstructions: 'ከላይ ያለውን የሂሳብ ቁጥር ወደ ባንክ አፕዎ ተጠቅሞ ጠቅላላ መጠኑን ያስተላልፉ፣ ከዚያ ከዚህ በታች የክፍያ ማስረጃዎን ያስገቡ።',
  uploadScreenshot: 'ስክሪንሾት ስቀል',
  enterReference: 'የማጣቀሻ ቁጥር አስገባ',
  orderConfirmation: 'ትዕዛዝ በተሳካ ሁኔታ ተቀምጧል! የትዕዛዝ መለያዎ',
  emptyCart: 'ጋሪዎ ባዶ ነው።',
  cartTotal: 'ጠቅላላ',
  unitPrice: 'የአንድ ዋጋ',
  quantity: 'ብዛት',
  lineTotal: 'ንዑስ ድምር',
  linkedOrder: 'ትዕዛዝ ምረጥ',
  deliveryAddress: 'የዴሊቨሪ አድራሻ',
  contactPhone: 'የእውቂያ ስልክ',
  preferredTime: 'የሚፈለግ የዴሊቨሪ ጊዜ',
  deliveryConfirmation: 'የዴሊቨሪ ጥያቄ ተልኳል! የጥያቄ መለያዎ',
  myStoreTab: '🛍️ የእኔ መደብር',
  myOrdersTab: '📦 የእኔ ትዕዛዞች',
  myPurchasesTab: '🛒 ግዢዎቼ',
  productName: 'የምርት ስም',
  productDescription: 'መግለጫ',
  productPrice: 'ዋጋ (ብር)',
  productCategory: 'ምድብ',
  productStock: 'የክምችት ብዛት',
  productPhotos: 'ፎቶዎች (እስከ 5)',
  productNotFound: 'ምርቱ አልተገኘም።',
  sellerNotFound: 'ሻጩ አልተገኘም።',
  outOfStockError: 'አንዳንድ ምርቶች ክምችት አልቋቸዋል።',
  deliveryDuplicateError: 'ለዚህ ትዕዛዝ የዴሊቨሪ ጥያቄ አስቀድሞ አለ።',
  loginRequired: 'ለመቀጠል እባክዎ ይግቡ።',
  backToBazaar: '← ወደ ባዛር ተመለስ',
  allCategories: 'ሁሉም ምድቦች',
  allSellers: 'ሁሉም ሻጮች',
  minPrice: 'ዝቅተኛ ዋጋ',
  maxPrice: 'ከፍተኛ ዋጋ',
  viewCart: 'ጋሪ ይመልከቱ',
  bankManagement: 'የባንክ ሂሳቦች',
  addBankAccount: 'የባንክ ሂሳብ ጨምር',
  noOrders: 'እስካሁን ትዕዛዞች የሉም።',
  noDeliveryRequests: 'እስካሁን የዴሊቨሪ ጥያቄዎች የሉም።',
  waitingConfirmation: 'የሻጩን ማረጋገጫ በመጠባበቅ ላይ።',

  // Buyer account
  registerAsSeller: 'እንደ ሻጭ ተመዝገብ',
  registerAsBuyer: 'እንደ ገዢ ተመዝገብ',
  buyerRegisterTitle: 'የገዢ መለያ ይፍጠሩ',
  myOrders: 'የእኔ ትዕዛዞች',
  buyerDashboardTitle: 'የግዢ ታሪኬ',
  purchaseHistory: 'የግዢ ታሪክ',
  groupedByCategory: 'በምድብ',
  groupedBySeller: 'በሻጭ',
  noPurchases: 'እስካሁን ምንም ግዢ የለም።',
  instantlyActive: 'መለያዎ ንቁ ነው!',
  buyerRegisterSuccess: 'ምዝገባ ተሳክቷል!',

  // Home extras
  connectWithUs: 'እኛን ያግኙ',
  ourRoots: 'መሬታችን',
  bridgingTitle: 'ባህላዊነትን እና',
  bridgingHighlight: 'ፈጠራን መካከል',
  rootsText: 'የኢትዮጵያ MSMEዎችን በዓለም አቀፍ ዲጂታል መልክዓ ምድር ውስጥ እንዲያድጉ እንረዳለን፣ ሀብታም ባህላችን እንዲጠብቁ በመሆን። ከአካባቢ ገበያዎች እስከ ዲጂታል ሱቃኖች፣ በእድገት ባጋሪ ነን።',
  ourStory: 'ታሪካችን',
  ourServicesTag: 'አገልግሎቶቻችን',
  whatWeDeliver: 'ምን እንቀርባለን',
  whatWeDeliverHighlight: 'አገልግሎት',
  viewMore: 'ተጨማሪ ይመልከቱ →',
  servicesBoost: 'ንግድዎን ለማሳደግ የምንሰጥ አገልግሎቶች',
  readyToScale: 'ንግድዎን ለማጋልጥ ዝግጁ ነዎት?',
  joinEntrepreneurs: 'በዲጂታል ታይነታቸው የሚያድጉ በርካታ የኢትዮጵያ ስራ ፈጣሪዎችን ይቀላቀሉ።',
  appStore: 'አፕ ሱቅ',
  googlePlay: 'ጉግል ፕሌይ',

  // Service cards
  svcSocialMedia: 'የሶሻል ሚዲያ አስተዳደር',
  svcSocialMediaDesc: 'የሶሻል ሚዲያ መለያዎችዎን በደጋሚ ማስቀመጥ፣ ተከታይ ተሳትፎ እና ይዘት ስትራቴጂ ሙሉ አስተዳደር።',
  svcContentCreation: 'ይዘት መፍጠር',
  svcContentDesc: 'የብራንድ ታሪክዎን የሚነግሩ እና ታሪኮችን የሚይዙ ሙያዊ ፎቶዎች፣ ቪዲዮዎች እና ግራፊክስ።',
  svcGrowthStrategy: 'የዕድገት ስትራቴጂ',
  svcGrowthDesc: 'ንግድ እድገትዎን ማፍጠን እና የገበያ ትስስር ለማስፋፋት የተነሳ የውሂብ ስትራቴጂዎች።',
  svcPaidAds: 'የሚከፈልበት ማስታወቂያ',
  svcAdsDesc: 'በሁሉም መድረኮች ላይ ROI ማስፋፋት እና ትክክለኛ ተወዳጅን ማድረስ ዒላማ ያደረጉ ማስታወቂያ ዘመቻዎች።',
  svcBranding: 'ብራንዲንግ እና ሎጎ ዲዛይን',
  svcBrandingDesc: 'የሚታወቀ የብራንድ ማንቂያ፣ ሎጎ መፍጠር እና ከተፎካካሪዎች የሚለይ የምስል ታሪክ።',
  svcOutdoor: 'የውጪ ማስታወቂያ',
  svcOutdoorDesc: 'የዲጂታል ማርኬቲንግ ጥረትዎን ለማጠናከር ባይልቦርዶች፣ ባነሮች እና የውጪ ታይነት መፍትሄዎች።',
  svcEcommerce: 'ኢ-ኮሜርስ ማስቀመጥ',
  svcEcomDesc: 'ሙሉ የመዝገቢ ሱቅ ማስቀመጥ፣ የምርት ዝርዝር እና በኦል ቲንግስ ባዛር ገበያ ማተም።',
  svcConsultation: 'የንግድ ምክር',
  svcConsultDesc: 'ንግድዎን በዲጂታል መልክዓ ምድር በተሳካ ሁኔታ እንዲያቀርብ የሚረዳ ባለሙያ መሪ እና ስትራቴጂካዊ ምክር።',

  // Clients extras
  ourPartners: 'ጋባሪ',
  ourPartnersHighlight: 'ማኅበረሰቦች',
  partnersDesc: 'ከኦል ቲንግስ ጋር ዲጂታል ታይነታቸውን የሚያስፋፉ የኢትዮጵያ ኢንोቬቲቭ ንግዶችን ይወቁ።',
  category: 'ምድብ',
  allCategoriesLabel: 'ሁሉም ምድቦች',
  city: 'ከተማ',

  // News extras
  updatesTag: 'ማሻሻያዎች',
  latestNews: 'የቅርብ ጊዜ',
  latestNewsHighlight: 'ዜና',
  newsDesc: 'በኢትዮጵያ ዲጂታል ኢኮኖሚ ውስጥ ባሉ የቅርብ ጊዜ ለውጦች መረጃ ያግኙ።',
  sources: 'ምንጮች',

  // Team extras
  viewProfile: 'መገለጫ ይመልከቱ',

  // Dashboard extras
  personalInformation: 'የግል መረጃ',
  businessInformation: 'የንግድ መረጃ',
  yearEstablished: 'የተቋቋመበት ዓመት',
  numberOfEmployees: 'የሰራተኞች ብዛት',
  socialMediaExtra: 'ሶሻል ሚዲያ እና ተጨማሪ ዝርዝሮች',
  instagramHandle: '📸 ኢንስታግራም ማለፊያ',
  tiktokHandle: '🎵 ቲክቶክ ማለፊያ',
  telegramLabel: '✈️ ቴሌግራም',
  facebookPage: '📘 ፌስቡክ ገጽ',
  servicesNeeded: 'የሚፈልጉ አገልግሎቶች',
  servicesNeededPlaceholder: 'ለምሳሌ፦ የሶሻል ሚዲያ አስተዳደር፣ ይዘት መፍጠር...',
  aboutYourBusiness: 'ስለ ንግድዎ',
  aboutYourBusinessPlaceholder: 'ስለ ንግድዎ ይንግሩን...',

  // Order labels
  orderNumber: 'ትዕዛዝ #',
  bank: 'ባንክ',
  proof: 'ማስረጃ',
  screenshot: 'ስክሪንሾት',
  ref: 'ማጣቀሻ',

  // Marketplace — hardcoded text localized
  mpTopAllCategories: 'ሁሉም ምድቦች',
  mpTopSearchPlaceholder: 'ምርቶችን፣ ንግዶችን፣ ምድቦችን ይፈልጉ...',
  mpTopDashboard: 'ዳሽቦርድ',
  mpTopRegister: 'ተመዝገብ',
  mpSearchAllCategories: 'ሁሉም ምድቦች',
  mpSearchAllCities: 'ሁሉም ከተሞች',
  mpTapToRead: 'ለማንበብ ይንኩ ▼',
  mpVisitStore: 'ሱቅ ይጎብኙ →',
  mpSales: 'ሽያጮች',
  mpProducts: 'ምርቶች',
  mpPaymentCreditCard: 'የብድር ካርድ',
  mpPaymentBankTransfer: 'የባንክ ዝውውር',
  mpPaymentMobileMoney: 'የሞባይል ገንዘብ',
  mpPaymentCashDelivery: 'በአደረሳጅ ላይ ክፍያ',
  mpPaymentTelebirr: 'ቴሌብር',
  mpFooterHome: 'ዋና ገጽ',
  mpFooterBazaar: 'ባዛር',
  mpFooterAbout: 'ስለ እኛ',
  mpFooterContact: 'ያግኙን',
  mpFooterNews: 'ዜና',
  mpFooterTeam: 'ቡድን',
  mpFooterRegister: 'ተመዝገብ',
  mpFooterDashboard: 'ዳሽቦርድ',
  mpFooterSellerGuide: 'የሻጭ መመሪያ',
  mpFooterPricing: 'ዋጋ አሰጣጥ',
  mpFooterFAQ: 'ተ.ጥ',
  mpFooterContactUs: 'ያግኙን',
  mpFooterPrivacy: 'የግላዊነት ፖሊሲ',
  mpFooterTerms: 'የአገልግሎት ውል',
  mpFooterEthiopia: '🇪🇹 ኢትዮጵያ',
  mpFooterEnglish: 'እንግሊዝኛ',

  // Marketplace Homepage
  mpHeroTag: "Ethiopia's #1 Marketplace for Verified Businesses",
  mpHeroTitle: "Ethiopia's #1 Marketplace for",
  mpHeroTitleHighlight: 'Verified Businesses',
  mpHeroDesc: 'Discover trusted Ethiopian businesses, shop quality products, and grow your brand on Africa\'s rising digital marketplace.',
  mpStartShopping: 'Start Shopping →',
  mpRegisterBusiness: 'Register Your Business',
  mpStatBusinesses: 'Verified Businesses',
  mpStatProducts: 'Products Listed',
  mpStatCities: 'Cities Covered',
  mpStatSatisfaction: 'የደንበኛ እርካታ',
  mpSearchCategory: 'Category',
  mpSearchLocation: 'Location',
  mpSearchKeyword: 'What are you looking for?',
  mpSearchBtn: 'Search',
  mpTrustVerified: 'Verified Businesses',
  mpTrustSecure: 'Secure Payments',
  mpTrustReturns: 'Easy Returns',
  mpTrust247: '24/7 Support',
  mpTrustVerifiedDesc: 'All businesses are licensed and verified',
  mpTrustSecureDesc: 'Protected transactions every step',
  mpTrustReturnsDesc: 'Hassle-free return policy',
  mpTrust247Desc: 'We are here to help anytime',
  mpCatTag: 'Categories',
  mpCatTitle: 'Shop by',
  mpCatTitleHighlight: 'Category',
  mpCatDesc: 'Browse thousands of products across popular categories',
  mpFeaturedTag: 'Featured',
  mpFeaturedTitle: 'Featured',
  mpFeaturedTitleHighlight: 'Verified Businesses',
  mpFeaturedDesc: 'Top-rated businesses handpicked for quality and trust',
  mpToolsTag: 'MSME Tools',
  mpToolsTitle: 'Everything You Need to',
  mpToolsTitleHighlight: 'Succeed',
  mpToolsDesc: 'Powerful tools designed specifically for Ethiopian MSMEs',
  mpPartnersTag: 'Partners',
  mpPartnersTitle: 'Our Financial',
  mpPartnersTitleHighlight: 'Partners',
  mpPartnersDesc: 'Trusted by leading Ethiopian financial institutions',
  mpPaymentsTag: 'Payments',
  mpPaymentsTitle: 'Secure Payment',
  mpPaymentsTitleHighlight: 'Methods',
  mpPaymentsDesc: 'Multiple secure payment options for your convenience',
  mpTestimonialTag: 'Testimonials',
  mpTestimonialTitle: 'What Our',
  mpTestimonialTitleHighlight: 'Sellers Say',
  mpTestimonialDesc: 'Hear from businesses thriving on All Things',
  mpNewsletterTitle: 'Stay Updated',
  mpNewsletterDesc: 'Subscribe to get the latest deals, new products, and marketplace news delivered to your inbox.',
  mpNewsletterPlaceholder: 'Enter your email',
  mpNewsletterBtn: 'Subscribe',
  mpNewsletterSuccess: '✓ Thank you for subscribing!',
  mpFooterDesc: "Ethiopia's premier digital marketplace connecting verified businesses with customers across the nation.",
  mpFooterQuickLinks: 'Quick Links',
  mpFooterForSellers: 'For Sellers',
  mpFooterSupport: 'Support',
  mpFooterCopyright: '© 2026 All Things Solution PLC. All rights reserved.',
};

export default am;
